import React from 'react'
import styles from "../RecipientList.styles"

import { useDispatch, useSelector } from 'react-redux'

import { componentKey, setBulkInActivateModalOpen, setBulkReActivateModalOpen } from '../RecipientListSlice'
import { componentKey as recipentSectionSliceComponentKey } from "../../RecipientsSectionSlice"
import { BUTTON_TYPE } from '../../../../components/button/constants'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'

import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { bulkInactivate, bulkReactivate } from '../RecipientListSaga'
import Loadable from '../../../../components/loadable/Loadable'
import { RECIPIENT_SECTION_LOADING_STATES } from '../../constants'
import { RECIPIENT_LISTING_LOADING_STATES, RECIPIENT_LISTING_MESSAGE_MAP } from '../constants'

const BulkActiveReactiveModals = () => {

    const dispatch = useDispatch()

    const { loadingState, bulkInActivateModalOpen, bulkReActivateModalOpen, selectedRecipients } = useSelector(state => state[componentKey])
    const { selectedPayer } = useSelector(state => state[recipentSectionSliceComponentKey])

    return (
        <Loadable
            currentState={loadingState?.state}
            loadingStates={[RECIPIENT_LISTING_LOADING_STATES.BULK_INACTIVATE_LOADING, RECIPIENT_LISTING_LOADING_STATES.BULK_REACTIVATE_LOADING]}
            messageMap={RECIPIENT_LISTING_MESSAGE_MAP}
            preserveChildMount={true}
            isNewLoadable={true}
        >
            {/* Inactivate Modal */}
            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Do you want to Inactivate all recipients under selected payer or Inactivate only selected recipients ?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={bulkInActivateModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.map(item => item.RecipentDetailId), selectAll: true }
                        dispatch(bulkInactivate(data))
                    },
                    confirmationButtonText: "Inactivate All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.map(item => item.RecipentDetailId), selectAll: false }
                        dispatch(bulkInactivate(data))
                    },
                    onCloseCb: () => {
                        dispatch(setBulkInActivateModalOpen(false))
                    },
                    cancelButtonText: "Inactivate Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                customStyle={styles.tinMatchPopup}
            />


            {/* Reactivate Modal */}
            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Do you want to Reactivate all recipients under selected payer or Reactivate only selected recipients ?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={bulkReActivateModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.map(item => item.RecipentDetailId), selectAll: true }
                        dispatch(bulkReactivate(data))
                    },
                    confirmationButtonText: "Reactivate All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: selectedRecipients.map(item => item.RecipentDetailId), selectAll: false }
                        dispatch(bulkReactivate(data))
                    },
                    onCloseCb: () => {
                        dispatch(setBulkReActivateModalOpen(false))
                    },
                    cancelButtonText: "Reactivate Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                customStyle={styles.tinMatchPopup}
            />


        </Loadable>
    )
}

export default BulkActiveReactiveModals
